























import { Vue, Component, Prop } from 'vue-property-decorator';
import { routeHelper } from '../../utils/routeHelper';
import { getKiyaku } from '../../kiyaku_tea';
import { WebUtils } from '../../utils/WebUtils';

@Component
export default class TeacherTermOfUsePage extends Vue {
  private building_id = '';
  goNextPage() {
    routeHelper(this, 'TeacherInfoInputMain');
  }
  get kiyaku() {
    return getKiyaku(this.building_id);
  }
  created() {
    this.building_id = WebUtils.getQueryItem('building', location) || '';
  }
}
